<template>
    <div class="d-flex flex-column">
        <div>
            <custom-dropdown :value="value" v-model="selectedGCU" :spacing="null" trackBy="name" optionsLabel="name" :multiple="false" placeholder="Select GCU"
                label="GCU" :options="gcuChoices" :disabled="!selectedSite" :invalid="gcuInvalid" cacheKey="gcu_commandCentre" :dependent="selectedSite"
                @input="handleGCUSelected">
            </custom-dropdown>
            <h6 style="color: #FF0000" v-if="gcuInvalid">{{ this.selectedGCU.name }} is currently offline.</h6>
        </div>
        <p class="commands-header">Commands</p>
        <div class="scrollable flex-grow-1">
            <div v-for="(command, index) in commands" :key="index">
                <div class="d-flex flex-row">
                    <div class="flex-grow-1">
                        <h6>{{ command.short_description }}</h6>
                        <p>{{ command.long_description }}</p>
                    </div>
                    <div>
                        <b-button variant="outline-primary" size="sm" :disabled="!commandsEnabled" @click="handleCommandClick(index)">
                            <i class="icon-paper-plane" />
                        </b-button>
                    </div>
                </div>
                <div class="dropdown-divider" v-if="index < commands.length - 1"></div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomDropdown from '../components/CustomDropdown';
import { mapGetters } from 'vuex';

export default {
  name: 'CommandCentreActions',
  components: {
    CustomDropdown
  },
  props: {
    gcuChoices: Array,
    selectedSite: Object,
    value: Object
  },
  data() {
    return {
        selectedGCU: null,
        commands: [],
    };
  },
  computed: {
    ...mapGetters('savanna/gcus', {
      gcuStatus: 'getGCUStatus'
    }),
    commandsEnabled() {
      if (this.selectedGCU && this.gcuStatus(this.selectedGCU.id) === 'ONLINE') return true;
      return false;
    },
    gcuInvalid() {
      if (this.selectedGCU && this.gcuStatus(this.selectedGCU.id) === 'OFFLINE') {
        return true;
      }
      return false;
    },
  },
  methods: {
    handleGCUSelected() {
      this.$emit('input', this.selectedGCU);
    },
    handleCommandClick(index) {
      this.$emit('commandClick', this.commands[index]);
    }
  },
  watch: {
    selectedSite: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (!newVal) return;
        if (oldVal && newVal.id === oldVal.id && newVal.name === oldVal.name) return;

        try {
          this.commands = await this.$api.get(`/v1/sites/${newVal.id}/commands`)
        } catch (err) {
          this.showError();
        }
      }
    },
    value(val) {
      this.selectedGCU = val;
    }
  },
  notifications: {
    showError: {
      type: 'error',
      title: 'Error',
      message: 'Error fetching site commands'
    }
  }
};
</script>

<style scoped>
.scrollable {
  height: 100px;
  overflow-y: scroll;
  border: 1px solid #e8e8e8;
  border-radius: 0.25rem;
  padding: 8px;
}

.commands-header {
  margin-bottom: 8px;
}
</style>
